<template>
<v-container grid-list-xl class="pa-0">
   <v-layout row>
    <v-flex xs 12>
      <h3 class="headline">Poderes Asamblea <span v-if="assemblyData.description" class="body-2 font-weight-thin">{{ assemblyData.description }} {{ assemblyData.assembly_date && assemblyData.assembly_date.split('-')[0] }}</span></h3>
      <span v-if="Object.keys(assemblyData).length > 0" :class="isAssemblyPast ? 'danger--text' : 'info--text'">Fechas autorizadas: {{ assemblyData.delegated_powers_date_start }} a {{ assemblyData.delegated_powers_date_limit }}</span>
      <div v-if="assemblyError">
        <v-alert 
          :value="true" color="warning" icon="priority_high" outline>
          {{ assemblyError}}
        </v-alert>
      </div>
    </v-flex>
  </v-layout>
  <v-layout v-if="Object.keys(assemblyData).length == 0" align-center justify-center>
    <div 
      v-if="isLoading"
      class="text-xs-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      >
      </v-progress-circular>
      <div class="primary--text">Cargando información de asamblea</div>
    </div>
    <div v-else-if="assemblyIsClosed">
      No hay asambleas activas
    </div>
  </v-layout>
  <v-layout v-else-if="!assemblyError" row tabs>
    <v-flex md12 lg12 xl10 >
      <v-tabs  v-model="tab" align-left color="grey lighten-2" slider-color="accent" md12 lg12 xl12 class="elevation-2" >
        <v-tab key="to_power">Apoderar</v-tab>
        <v-tab key="accept_powers">Aceptar Poderes <span v-if="delegated_powers_limit > 0" class="pl-2">({{ Object.keys(powersReceived).length }}/{{ delegated_powers_limit }})</span></v-tab>
        <v-tab-item key="to_power">
          <v-card flat>
            <v-card-text v-if="balance == 0 && Object.keys(powerGranted).length == 0 && Object.keys(powersReceived).length == 0 && activeStudent > 0">
              Seleccione esta opción <b>si necesita que alguien lo represente en la asamblea ya que por algún motivo no puede asistir</b><br>
              <v-btn  
                href="https://app.columbus.edu.co/app/storage/guides/como_otorgar_poder_asamblea.mp4"
                target="blank"
                color="green success"
                class="white--text"
                >
                <v-icon left dark class="mr-2">movie</v-icon> Ver tutorial
              </v-btn>
              <v-layout row>
                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    v-if="familyId"
                    v-model="currentFamilySearch"
                    :items="familyResult"
                    :search-input.sync="searchFamily"
                    color="primary"
                    hide-no-data
                    hide-selected
                    item-text="name"
                    item-value="name"
                    placeholder="Buscar familia"
                    cache-items
                    clearable
                    return-object
                    :error="inputSearchError"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <div v-if="isLoading"  class="text-center">
                    <v-progress-circular
                      indeterminate
                      class="mt-3 pr-12"
                      color="primary"
                    >
                    </v-progress-circular>
                    <span class="primary--text pa-2">Espere...</span>
                    
                  </div>
                  <v-alert 
                    v-else-if="!isLoading && currentFamilySearch && Object.keys(targetPowerGranted).length == 0 && 
                      Object.keys(targetPowersReceived).length < delegated_powers_limit && 
                      Object.keys(targetAssemblyMember).length == 0 && targetBalance == 0 &&
                      targetActiveStudent > 0"
                    :value="true" color="success" icon="check_circle" outline>
                    Puede seleccionar esta familia para otorgarle su poder.

                    <v-btn :loading="isLoading" :disabled="!currentFamilySearch" 
                      @click="giveOrTakePower('give')" 
                      color="primary"><v-icon>check</v-icon> Asignar</v-btn>
                  </v-alert>
                  <v-alert 
                    v-else-if="currentFamilySearch && Object.keys(targetPowerGranted).length > 0"
                    :value="true" color="warning" icon="priority_high" outline>
                    Esta familia ya otorgó su poder, no puede seleccionarla.
                  </v-alert>
                  <v-alert 
                    v-else-if="currentFamilySearch && Object.keys(targetPowersReceived).length >= delegated_powers_limit"
                    :value="true" color="warning" icon="priority_high" outline>
                    Esta familia tiene la totalidad de poderes permitidos. No puede aceptar más.
                  </v-alert>
                  <v-alert v-else-if="Object.keys(targetAssemblyMember).length > 0 && targetAssemblyMember.is_employee" 
                    :value="true" color="warning" icon="warning" outline>
                    Esta familia es de un empleado. <b>No puede gestionar poderes.</b>
                  </v-alert>
                  <v-alert v-else-if="Object.keys(targetAssemblyMember).length > 0 && targetAssemblyMember.is_member"
                    :value="true" color="warning" icon="warning" outline>
                    Esta familia es miembro de junta para esta asamblea. <b>No puede gestionar poderes</b>
                  </v-alert>
                  <v-alert v-else-if="targetActiveStudent == 0"
                    :value="true" color="warning" icon="warning" outline>
                    Esta familia no tiene estudiantes activos. <b>No puede gestionar poderes</b>
                  </v-alert>
                  <v-alert 
                    v-else-if="currentFamilySearch && parseFloat(targetBalance) > 0"
                    :value="true" color="warning" icon="priority_high" outline>
                    Esta familia no está habilitada para recibir poderes.
                  </v-alert>
                  <v-alert 
                    v-else
                    :value="true" color="info" icon="info" outline>
                    Seleccione la familia a <b>Apoderar</b>
                  </v-alert>
                  <!-- {{ currentFamilySearch }} y {{ searchFamily }} y {{ familyResult.length }} -->
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text v-else-if="Object.keys(powerGranted).length > 0 && powerGranted.family_receives_power_status == 'R'">
              <v-alert :value="true" color="warning" icon="warning" outline>
                Ya otorgó un poder anteriormente a la familia <b>{{ powerGranted.family_name }}</b>. Sin embargo, fue rechazado por la familia. Puede recuperar dicho poder.
                 <v-btn @click="giveOrTakePower('regain_give')" :loading="isLoading" :disabled="isLoading" color="warning"><v-icon class="mr-2">undo</v-icon> Recuperar poder</v-btn>
              </v-alert>
            </v-card-text>
             <v-card-text v-else-if="Object.keys(powerGranted).length > 0 && powerGranted.document_status == 'R'">
              <v-alert :value="true" color="warning" icon="warning" outline>
                Ya otorgó un poder anteriormente a la familia <b>{{ powerGranted.family_name }}</b>. Sin embargo, fue rechazado por el administrador. <br>
                Puede firmar nuevamente, o recuperar dicho poder.
                 <v-btn @click="giveOrTakePower('retry_give')" color="primary" :disabled="isLoading" :loading="isLoading"><v-icon class="mr-2">cached</v-icon> Firmar nuevamente</v-btn>
                 <v-btn @click="giveOrTakePower('regain_give')" color="warning" :disabled="isLoading" :loading="isLoading"><v-icon class="mr-2">undo</v-icon> Recuperar poder</v-btn>
              </v-alert>
            </v-card-text>
            <v-card-text v-else-if="Object.keys(powerGranted).length > 0 && powerGranted.document_signed != null && powerGranted.document_status != 'R'">
              <v-alert :value="true" color="success" icon="check_circle" outline>
                Ya otorgó un poder a la familia <b>{{ powerGranted.family_name }}</b>. 
                <v-btn
                  color="primary"
                  @click="handleSign('give')" >
                  <v-icon class="mr-2">picture_as_pdf</v-icon>
                  Visualizar Poder
                </v-btn>
              </v-alert>
            </v-card-text>
            <v-card-text v-else-if="Object.keys(powersReceived).length > 0">
              <v-alert :value="true" color="warning" icon="warning" outline>
                Tiene {{ powersReceived.length }} poder(es) asignado(s). No puede otorgar el suyo.
              </v-alert>
            </v-card-text>
            <v-card-text v-else-if="alreadyAssist && assemblyData.assembly_is_active == '1'">
              <v-alert :value="true" color="warning" icon="warning" outline>
                Ya inició su asistencia a la asamblea activa. No puede otorgar su poder ahora.
              </v-alert>
            </v-card-text>
            <!-- 
            NOTA: EMPLEADO O MIEMBRO DE JUNTA: Solo puede entregar poderes (y votar). No pueden recibir poderes (ninguno de los dos casos).
            <v-card-text v-else-if="Object.keys(assemblyMember).length > 0 && assemblyMember.is_employee">
              <v-alert :value="true" color="warning" icon="warning" outline>
                Usted es empleado. <b>No puede gestionar poderes.</b>
              </v-alert>
            </v-card-text>
            <v-card-text v-else-if="Object.keys(assemblyMember).length > 0 && assemblyMember.is_member">
              <v-alert :value="true" color="warning" icon="warning" outline>
                Usted es miembro de junta para esta asamblea. <b>No puede gestionar poderes</b>
              </v-alert>
            </v-card-text> -->
            <v-card-text v-else-if="activeStudent == 0">
              <v-alert :value="true" color="warning" icon="warning" outline>
                Sin estudiantes activos para la familia {{ familyId }}.
              </v-alert>
            </v-card-text>
             <v-card-text v-else-if="parseFloat(balance) > 0">
              <v-alert :value="true" color="warning" icon="warning" outline>
                No se encuentra habilitado para apoderar o recibir poderes, dado que no se encuentra a paz y salvo por todo concepto con la corporación al mes de febrero de {{ new Date().getFullYear() }}. <!-- {{ balance }}-->
              </v-alert>
            </v-card-text>
            <v-card-text v-else-if="Object.keys(powerGranted).length > 0 && powerGranted.document_signed == null">
              <v-layout v-if="powerGranted.target_powers_number <= delegated_powers_limit" row>
                <v-flex xs12 sm6 md6 >
                  <div style="min-height: 70px">
                    Ha otorgado su poder a la familia <b>{{ powerGranted.family_name }}</b>, sin embargo, dicho poder no será efectivo sino diligencia su respectiva firma digital:
                  </div>
                  <v-btn @click="handleSign('give')" :loading="isLoading" color="primary"><v-icon class="mr-2">done</v-icon> Firmar Poder</v-btn>
                </v-flex>
                <v-divider vertical ></v-divider>
                <v-flex xs12 sm6 md6>
                  <div style="min-height: 70px">
                    Si desea cambiar de decisión y seleccionar otra familia: 
                  </div>
                  <v-btn @click="giveOrTakePower('regain_give')" :loading="isLoading" color="warning"><v-icon class="mr-2">undo</v-icon> Recuperar poder</v-btn>
                </v-flex>
              </v-layout>
              <v-layout v-else row>
                <v-flex xs12 sm8 md8>
                  <div style="min-height: 70px">
                    La familia destino <b>{{ powerGranted.family_name }}</b> ya tiene a su cargo <b>{{ powerGranted.target_powers_number }}</b>, y no puede recibir más poderes. Deberá recuperar su poder para gestionarlo nuevamente.
                  </div>
                  <v-btn @click="giveOrTakePower('regain_give')" :loading="isLoading" color="warning"><v-icon class="mr-2">undo</v-icon> Recuperar poder</v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text v-else>
              <!-- <v-alert v-if="!isLoading" :value="true" color="warning" icon="warning" outline>
                Existen inconvenientes con su cuenta.
              </v-alert> -->
              
                <!-- powerGranted: {{ powerGranted }} - {{ Object.keys(powerTaken).length }} y {{ powerGranted.document_signed }}<br>
                powerGranted: {{ powerTaken }}<br>
                powersReceived: {{ powersReceived }}<br>
                balance: {{ balance }} -->
              
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item key="accept_powers">
          <v-card flat>
            <v-card-text v-if="balance == 0 && Object.keys(powerGranted).length == 0">
              Seleccione esta opción <b>si va a representar una o varias familias</b>
              <v-btn  
                href="https://app.columbus.edu.co/app/storage/guides/como_aceptar_poder_asamblea.mp4"
                target="blank"
                color="green success"
                flat
                class="white--text"
                >
                <v-icon class="mr-2">movie</v-icon> Ver tutorial
              </v-btn>
            <v-data-table
              v-if="Object.keys(powersReceived).length > 0"
              v-model="selected"
              :headers="powersHeaders"
              :items="powersReceived"
              :items-per-page="10"
              :rows-per-page-text="$t('datatable.rowsPerPageText')"
              :no-results-text="$t('datatable.noResultsText')"
              :no-data-text="$t('datatable.noDataText')"
              :rows-per-page-items="[10,20,{'text':$t('datatable.allRowsPerPageItems'),'value':-1}]"
              :loading="isLoading"
              item-key="family_id"
              class="mt-2"
            >
              <template v-slot:items="props">
                  <td>{{ props.item.family_id }}</td>
                  <td>{{ props.item.family_name }}</td>
                  <td>{{ props.item.created_at.substring(0,16) }}</td>
                  <td class="justify-center" :class="props.item.document_status == 'R'">
                    {{ props.item.document_status == 'P' ? 'Pendiente' : props.item.document_status == 'F' ? 'Firmado' : props.item.document_status == 'R' ? 'Rechazado Administrador': 'Por firmar' }}
                    <span class='blue--text'>{{ props.item.reviewed ? 'Verificado' : '' }}</span>
                  </td>
                  <td class="justify-center text-no-wrap" :class="props.item.family_receives_power_status == 'A' ? 'success--text' : 'orange--text text--lighten-2'">
                      {{ props.item.family_receives_power_status == 'A' ? 'Aprobado' : 'Sin aprobar' }}
                      <br>
                      {{ props.item.family_receives_power_updated_at ? props.item.family_receives_power_updated_at.substring(0, 16) : '' }}
                  </td>
                  <td class="justify-center text-no-wrap">
                    <v-icon
                      v-if="props.item.family_receives_power_status != 'A'"
                      class="mr-2"
                      color="success"
                      :disabled="isLoading"
                      @click="openDialog(props.item, 'accept')"
                    >
                      done
                    </v-icon>
                    <v-icon
                      v-if="props.item.family_receives_power_status != 'A'"
                      color="red"
                      :disabled="isLoading"
                      @click="openDialog(props.item, 'reject')"
                    >
                      do_disturb
                    </v-icon>
                  </td>
              </template>
              <template v-slot:pageText="props">
                {{ props.pageStart }} - {{ props.pageStop }} {{ $t('datatable.pageTextOf') }} {{ props.itemsLength }}
              </template>
            </v-data-table>
            <br>
            <div v-if="Object.keys(powersReceived).length > 0">
              <span 
                v-if="Object.keys(powersReceived).length != powerFilter(powersReceived, 'A').length"
                class="warning--text">
                Tiene {{ Object.keys(powersReceived).length - powerFilter(powersReceived, 'A').length }} poder(es) pendiente(s) por gestionar (aceptar o rechazar). <br>
                Recuerde que puede recibir hasta {{ delegated_powers_limit }} poderes.<br>
              </span>
              <div 
                v-else-if="powerTaken && !powerTaken.document_signed" >
                Ha recibido, y aprobado <b>{{ Object.keys(powersReceived).length }} poderes</b>, sin embargo, dichos poderes no serán efectivos sino diligencia su respectiva firma digital:
              </div>
              <div 
                v-else-if="powerTaken && powerTaken.document_signed && powerTaken.document_status == 'F' && powerTaken.incoming_powers > 0" >
                Parece que tiene <b>{{ powerTaken.incoming_powers }} poderes adicionales</b> para recibir, puede firmar nuevamente para aceptar estos nuevos poderes.
                <v-btn
                  color="primary"
                  @click="giveOrTakePower('retry_take')"
                  :loading="isLoading"
                  :disabled="isLoading"
                   >
                  <v-icon class="mr-2">redo</v-icon>
                  Firmar nuevamente
                </v-btn>
              </div>
              <div 
                v-if="powerTaken && powerTaken.document_signed && powerTaken.document_status == 'F'" >
                <v-btn
                  color="primary"
                  @click="handleSign('take')" >
                  <v-icon class="mr-2">picture_as_pdf</v-icon>
                  Visualizar Poder
                </v-btn>
              </div>
              <div v-if="powerTaken.document_status == 'R'">
                <v-alert :value="true" color="warning" icon="warning" outline>
                  Su documento ha sido rechazado por el Administrador. Por favor verifique su correo para conocer el motivo (firma o fotografía).
                  Por favor, firme nuevamente el poder de aceptación.
                </v-alert>
                <v-btn @click="giveOrTakePower('retry_take')" color="primary" :disabled="isLoading" :loading="isLoading"><v-icon class="mr-2">cached</v-icon> Firmar nuevamente</v-btn>
                 <v-btn @click="giveOrTakePower('regain_give')" color="warning" :disabled="isLoading" :loading="isLoading"><v-icon class="mr-2">undo</v-icon> Recuperar poder</v-btn>
              </div>
              <v-btn 
                color="primary"
                v-if="Object.keys(powerTaken).length == 0"
                :disabled="Object.keys(powersReceived).length != powerFilter(powersReceived, 'A').length && !!powerTaken"
                :loading="isLoading"
                @click="giveOrTakePower('take')">
                Firmar Poder de Aceptación
              </v-btn>
              <v-btn v-else-if="powerTaken && !powerTaken.document_signed" 
                color="primary"
                :disabled="Object.keys(powersReceived).length != powerFilter(powersReceived, 'A').length"
                @click="handleSign('take')" >
                <v-icon class="mr-2">done</v-icon>
                Firmar Poder
              </v-btn>
            </div>
            <div v-else>
              <v-alert :value="true" color="warning" icon="warning" outline>
                Aún no tiene poderes a su encargo.
              </v-alert>
            </div>


            <!-- <pre>seleccionado: {{ selectedItem }}</pre> -->
            <v-dialog 
              v-model="dialog" 
              max-width="460px">
              <v-toolbar
                color="accent"
                dark
                dense
              >
                <v-toolbar-title class="font-weight-thin">
                  <v-icon dark>warning</v-icon> Acción requerida
                </v-toolbar-title>
              </v-toolbar>
              <v-card>
                <v-card-text class="subheading text-md-center">
                  
                  <span class="text-center">
                    ¿Desea <b>{{ $t(action).toLowerCase() }}</b> el poder otorgado por la familia <b>{{ selectedItem.family_name }}</b> para la Asamblea <b>{{ assemblyData.description }}</b>?
                  </span>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
                  <v-btn :color="action == 'accept' ? 'green darken-1' : 'red darken-1'" flat @click="handlePower">{{ $t(action) }} Poder</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            </v-card-text>
            
            <v-card-text v-else-if="parseFloat(balance) > 0">
              <v-alert :value="true" color="warning" icon="priority_high" outline>
                No se encuentra habilitado para apoderar o recibir poderes, dado que no se encuentra a paz y salvo por todo concepto con la corporación al mes de febrero de {{ new Date().getFullYear() }}.<!-- {{ balance }}-->
              </v-alert>
              <!--
                
                powerGranted: {{ powerGranted }}<br>
                powersReceived: {{ powersReceived }}<br>
                balance: {{ balance }}
                -->
            </v-card-text>
            <v-card-text v-else-if="Object.keys(powerGranted).length > 0 && powerGranted.document_signed != null">
              <v-alert :value="true" color="warning" icon="warning" outline>
                Ya otorgó su poder. No puede aceptar poderes.
              </v-alert>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>

      <v-dialog
        v-model="dialogDigitalSign"
        fullscreen>
        <!-- <v-layout>
          <v-flex style="background-color:white;" lg4>
            <b>signAction: {{ signAction }}</b><br>
            rowidTercero: {{ rowidTercero }}<br>
            documentSignId: {{ documentSignId }}<br>
            vistaAction: {{ vistaAction }}<br>
            documentProcessId: {{ documentProcessId }}<br>
            vistaRecordId: {{ vistaRecordId }}
          </v-flex>
        </v-layout> -->
        <DigitalSignComponent
          v-if="dialogDigitalSign"
          v-on:closeDialog="dialogDigitalSign = false; getStatus()"
          :studentId="rowidTercero"
          :documentId="documentSignId"
          :action="vistaAction"
          :processId="documentProcessId"
          :recordId="vistaRecordId"
        ></DigitalSignComponent>
      </v-dialog>
      
    </v-flex>
  </v-layout>
</v-container>
</template>
<script>
import axios from 'axios';
import DigitalSignComponent from '~/pages/documents/digital_sign'
import { mapGetters } from 'vuex'


export default {
  name: 'assembly-assistance-view',
  components: {
    DigitalSignComponent
  },
  data: () => ({
      tab: null,
      inputSearchError: false,
      currentFamilySearch: null,
      searchFamily: null,
      isLoading: false,
      assemblyError: null,
      userNameMaxLength: 60,
      families: [],

      familyHasError: null,
      familyErrorMessage: null,
      dialogDigitalSign: false,
      parents: null,
      physicalSignature: null,
      idAssembly: '',
      assemblyData: {},
      assemblyDocuments: {},
      actualPercent: 0,
      delegated_powers_limit: 0,
      quorum: 0,
      assemblyIsClosed: false,
      not_found: false,

      familyId: null,
      powerGranted: [],
      powersReceived: [],
      powerTaken: [],
      assemblyMember: [],
      activeStudent: null,
      alreadyAssist: false,
      balance: 0,
      targetPowerGranted: [],
      targetPowersReceived: [],
      targetPowerTaken: [],
      targetAssemblyMember: [],
      targetActiveStudent: null,
      targetBalance: 0,

      selected: [],
      powersHeaders: [
        { text: 'ID Familia ', value: 'family_id' },
        { text: 'Nombre Familia', value: 'family_name' },
        { text: 'Fecha solicitud', value: 'created_at' },
        { text: 'Revisión', value: 'document_status', align: 'center' },
        { text: 'Estado', value: 'family_receives_power_status', align: 'center' },
        { text: 'Acciones', value: 'actions', sortable: false }
      ],

      dialog: false,
      action: null,
      selectedIndex: -1,
      selectedItem: {
        family_id: null,
        family_name: null,
      },

      dialogDigitalSign: false,
      signAction: null,
      vistaRecordId: 0,
      rowidTercero: 0,
      documentSignId: 0,
      vistaAction: null,
      documentProcessId: 0,
      vistaRecordId: 0,
  }),
  created() {
    this.getAssembly()
    this.getFamilies()
  },
  methods: {    
    getStatus(family, add_action) {
      let id = family ? family.id : ''
      let context = this

      context.validatingFamily = family ? true : false
      context.isLoading = true
      axios.post(`/api/documents/power_validation`, {'id': id, 'id_assembly': context.idAssembly })
        .then(res => {
          const { data } = res
          if(!family){
            context.familyId = data.id
            context.powerGranted = data.power_granted;
            context.powersReceived = data.powers_received;
            context.balance = data.balance;
            context.powerTaken = data.power_taken;
            context.assemblyMember = data.assembly_member
            context.activeStudent = data.active_student
            context.alreadyAssist = data.assistance_validation;
            if (Object.keys(context.powersReceived).length > 0){
              context.tab = 1
            }
          } else {
            context.setTargetInfo(data)
          }
          if(add_action == 'retrySign'){
            context.handleSign('give')
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(function(){ 
          context.isLoading = false
          context.validatingFamily = false
        })
    },
    setTargetInfo(data){
      if (data){
        this.targetPowerGranted = data.power_granted
        this.targetPowersReceived = data.powers_received
        this.targetPowerTaken = data.power_taken
        this.targetBalance = data.balance
        this.targetAssemblyMember = data.assembly_member
        this.targetActiveStudent = data.active_student
      } else {
        this.targetPowerGranted = []
        this.targetPowersReceived = []
        this.targetPowerTaken = []
        this.targetBalance = 0
        this.targetAssemblyMember = []
        this.targetActiveStudent = null
      }      
    },
    getAssembly(){
      let context = this
      axios.get('/api/assembly/next/assistance')
        .then(response => {
          const { data, status } = response;
          if (status === 200) {
            if (data.not_found) {
              context.not_found = true;
              return;
            }
            context.assemblyData = data.assembly;
            context.assemblyDocuments = data.documents;
            context.actualPercent = data.actual_percent;
            context.quorum = data.quorum;
            context.delegated_powers_limit = data.assembly.delegated_powers_limit
            context.idAssembly = data.assembly.id;
            

            if (!data.documents){
              context.assemblyError = "No hay documentos de firma inscritos. Informe a soporte";
              context.isLoading = false
              return;
            }
            else if (context.isAssemblyPast){
              context.assemblyError = `Se ha terminado el plazo para el manejo de poderes (${context.assemblyData.delegated_powers_date_limit})`;
              context.isLoading = false
              return;
            } 
            else if (context.isAssemblyInFuture){
              context.assemblyError = `Aún no ha iniciado el plazo para el manejo de poderes (${context.assemblyData.delegated_powers_date_start})`;
              context.isLoading = false
              return;
            } else if (data.assembly.assembly_is_active == '1'){
              context.assemblyError = `Ya inició formalmente la asamblea. No puede realizar ninguna acción`;
              context.isLoading = false
              return;
            } else if (data.assembly.status == '1'){
              context.assemblyError = `Ya está cerrada la asamblea. No puede realizar ninguna acción`;
              context.isLoading = false
              return;
            } else if (data.assembly.status == 0 || data.assembly.status == "0") {
              context.assemblyIsClosed = false;
              context.getStatus()
            } 
          }
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          context.isLoading = false;
        })
    },
    openDialog(item, action){
      this.action = action
      this.dialog = true
      this.selectedItem = item
    },
    giveOrTakePower(action) {
      let context = this
      let payload = { family_id: null } // take, regain
      let url = '/api/documents/'
      if (action == 'retry_give'){
        payload = { family_id: context.powerGranted.family_receives_power_id, action: 'retry' }
        url += 'give_power'
      } else if (action == 'retry_take'){
        payload = { family_id: context.powerTaken.family_id, action: 'retry' }
        url += 'take_power'
      } else if (action == 'give') {
        url += 'give_power'
        payload = { family_id: context.currentFamilySearch.id }
      } else if (action == 'regain_give') {
        url += 'give_power'
        payload = { family_id: null, action: 'retry' }
      } else if (action == 'regain_take') {
        url += 'take_power'
        payload = { family_id: null, action: 'retry' }
      } else if (action == 'take') {
        url += 'take_power'
      }
      payload.id_assembly = context.idAssembly

      context.isLoading = true
      axios.put(url, payload)
        .then(resp => {
          if (resp.status === 200) {
            context.dialog = false
            context.$store.dispatch('responseMessage', {
                type: 'success',
                text:  action != 'retry_give' ? 'Actualizado correctamente' : 'Liberado correctamente',
                modal: false
            })
          }
        }).finally(() => {
          context.currentFamilySearch =  action != 'remove' ? context.currentFamilySearch : null
          if (action == 'retry'){
            context.getStatus(null, 'retrySign')
          } else {
            context.getStatus()
            context.isLoading = false
          }
        })
    },
    handlePower() {
      let context = this
      const payload = { 
          action: context.action.charAt(0).toUpperCase(), 
          assembly_name: context.assemblyData.description
        }
      axios.put(`/api/documents/power_action/${context.selectedItem.id}`, payload)
        .then(resp => {
          if (resp.status === 200) {
            context.dialog = false
            if (!resp.data.error){
              let mails_to = resp.data.mails_to
              context.$store.dispatch('responseMessage', {
                  type: 'success',
                  text: `Actualizado correctamente. ${ mails_to > 0 ? 'Notificación enviada ('+mails_to+' emails)' : '' }`,
                  modal: false
              })
              context.getStatus()
            } else {
              console.error("API response: ", resp.data.error)
              context.$store.dispatch('responseMessage', {
                  type: 'error',
                  title: 'Error',
                  text: `Ocurrió un error, reintente nuevamente`,
                  modal: false
              })
            }            
          }
        })
    },
    
    close () {
      this.dialog = false
      setTimeout(() => {
        this.selectedItem = Object.assign({}, this.defaultItem)
        this.selectedIndex = -1
      }, 300)
    },

    save () {
      if (this.selectedIndex > -1) {
        Object.assign(this.powersReceived[this.selectedIndex], this.selectedItem)
      } else {
        this.powersReceived.push(this.selectedItem)
      }
      this.close()
    },

    powerFilter(powers, filter){
      let powersCount = []
      if (powers && Object.keys(powers).length > 0){
        powersCount = powers.filter(power => power.family_receives_power_status == filter)
      }      
      return powersCount
    },
    
    handleSign(action) {
      let document = this.powerGranted
      this.documentSignId = this.assemblyDocuments.give_vista_document_id
      if(action == 'take'){
        document = this.powerTaken
        this.documentSignId = this.assemblyDocuments.take_vista_document_id
      }

      this.signAction = action
      if (document.document_status == 'F') {
        this.vistaAction = 'SHOW'
        this.vistaRecordId = document.document_signed;
        this.dialogDigitalSign = true
        return
      }

      if (document.document_status == 'P') {
        this.vistaAction = 'UPDATE'
        this.documentProcessId = document.id
        this.vistaRecordId = document.document_signed 
        this.dialogDigitalSign = true
        this.rowidTercero = document.student_number
        return
      }

      this.vistaAction = 'CREATE'
      this.documentProcessId = document.id
      this.rowidTercero =document.student_number
      this.dialogDigitalSign = true
    },
    closeSignDialog() {
      this.dialogDigitalSign = false
      this.documentSignId = 0
      this.documentProcessId = 0
      this.vistaAction = ''
      this.vistaRecordId = 0
      this.rowidTercero = 0
      this.init()
    },

    getFamilies(){
      let context = this
      axios.get(`/api/assembly/search_family/all`)
        .then(res => {
          const { data } = res
          context.families = data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(function() {
          context.isLoading = false
        })
    }
  },
  computed: {
    ...mapGetters({
      pageLoading: 'pageLoading'
    }),
    familyResult() {
      let context = this
      context.families = context.families.filter(function( obj ) {
          return obj.id !== context.familyId;
      });
      return context.families.map(user => {
        user.name.length > context.userNameMaxLength
          ? user.name.slice(0, context.userNameMaxLength) + '...'
          : user.name

        return Object.assign({}, user)
      })
    },
    isAssemblyPast(){
      let date = this.assemblyData.delegated_powers_date_limit
      const today = new Date().setHours(0,0,0,0)
      if (typeof(date) == 'string'){
        const split = date.split('-')
        date = new Date(split[0], split[1]-1, split[2]);
      }
      return today > date
    },
    isAssemblyInFuture(){
      let date = this.assemblyData.delegated_powers_date_start
      const today = new Date().setHours(0,0,0,0)
      if (typeof(date) == 'string'){
        const split = date.split('-')
        date = new Date(split[0], split[1]-1, split[2]);
      }
      return today < date
    }
  },
  watch: {
    currentFamilySearch(val){
      if (val){
        this.getStatus(val)
      }
    },
    pageLoading(val){
      this.isLoading = val
    },
    searchFamily(val) {
      let context = this
      context.familyHasError = false
      context.familyErrorMessage = ""
      context.dialogDigitalSign = false
      context.parents = {}
      context.physicalSignature = false
      if (!val) {
        context.isLoading = false
        return
      } else if (val.length == 1 && context.currentFamilySearch) {
        context.setTargetInfo()
        context.currentFamilySearch = null
      } else if (context.isLoading) return

      context.isLoading = true

    },
    dialog (val) {
      val || this.close()
    }
  }
}
</script>
<style>

</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/assembly/powers.vue